import LoadingBackdrop from 'components/LoadingBackdrop';
import useIncidentGenerator from 'containers/pages/generateIncidentReports/hooks/useIncidentGenerator';
import { IncidentReport } from 'containers/pages/generateIncidentReports/components/IncidentReport';
import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Grid, Button } from 'components/mui';
import styles from './GenerateIncidentReport.module.css';
/**
 * @component GenerateIncidentReport
 * @desc Component for generating incident reports. Is hit via activity report in cantrack-v3.
 * @returns {JSX.Element} The Contacts component.
 */
function GenerateIncidentReport() {
	const { incidentData } = useIncidentGenerator();

	return (
		<>
			{incidentData ? (
				<IncidentReportViewer incidentData={incidentData} />
			) : (
				<LoadingBackdrop open={true} />
			)}
		</>
	);
}

const IncidentReportViewer = ({ incidentData }) => {
	const documentName = `Incident Report(#${incidentData.CommentListID}) ${incidentData.GuardName}.pdf`;
	return (
		<BlobProvider
			document={
				<IncidentReport
					incident={incidentData}
					documentName={documentName}
				/>
			}
		>
			{({ blob, url, loading, error }) => {
				if (loading) {
					return <div>Loading document...</div>;
				}

				if (error) {
					return <div>Error generating document</div>;
				}

				return (
					<Grid container className={styles.container}>
						<Button
							variant="contained"
							color="primary"
							component="a"
							href={url}
							download={documentName}
						>
							Download
						</Button>
						<Grid className={styles.pdfViewerWrapper}>
							<iframe
								title={documentName}
								src={url}
								className={styles.pdfViewer}
							/>
						</Grid>
					</Grid>
				);
			}}
		</BlobProvider>
	);
};
export default GenerateIncidentReport;
